module.exports = __webpack_public_path__ + "img/admin-photo.6727f5f0.png";